import React from 'react';

export const ResourceModalStyles: React.FC = () => {
  return (
    <style>
      {`
        .provider-details-scroll::-webkit-scrollbar {
          width: 9px;
        }
        .provider-details-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .provider-details-scroll::-webkit-scrollbar-thumb {
          background-color: #d9d9d9;
          border-radius: 100px;
        }
        .resource-modal-scroll::-webkit-scrollbar {
          width: 8px;
        }
        .resource-modal-scroll::-webkit-scrollbar-track {
          background: transparent;
        }
        .resource-modal-scroll::-webkit-scrollbar-thumb {
          background-color: #d9d9d9;
          border-radius: 100px;
        }
        @media (max-width: 767px) {
          dialog[open].resource-modal-mobile {
            top: auto;
            bottom: 0;
            margin: 0;
            padding: 0 !important;
            height: calc(100vh - 2rem) !important;
            max-height: calc(100vh - 2rem) !important;
          }
          dialog[open].resource-modal-mobile > div {
            height: 100% !important;
            max-height: 100% !important;
          }
        }
      `}
    </style>
  );
};
